import {flowRight as compose} from 'lodash';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import styled from 'styled-components';
import SearchIcon from '../../../common/components/SearchIcon';
import {withLoadedUser} from '../../../login/containers/AuthBase';

import DownloadReceipt from './DownloadReceipt';
import TicketDetailsModal from './TicketDetailsModal';

const Flex = styled.div`
  display: flex;
  align-items: center;
`;

const TicketRowActionMerchant = ({receipt}) => {
  const [modalVisible, setModalVisible] = useState(false);

  return (
    <Flex>
      <div>
        <div className="btn-disable">
          <DownloadReceipt receipt={receipt}/>
          <SearchIcon onClick={() => setModalVisible(true)}/>
        </div>
        <TicketDetailsModal showModal={modalVisible} receipt={receipt} changeModalState={setModalVisible} />
      </div>
    </Flex>
  );
};

TicketRowActionMerchant.propTypes = {
  receipt: PropTypes.shape({
    isDeleted: PropTypes.bool.isRequired,
    id: PropTypes.string.isRequired,
  }).isRequired,
  currentUser: PropTypes.object.isRequired,
};

export default compose(
  withLoadedUser,
)(TicketRowActionMerchant);
